import {getCookie, setCookie, deleteCookie} from "@/services/utils.service";

// Единый вход (Б-3): на боевых поддоменах *.antilaundry.ru токен кладём на
// родительский домен, чтобы его видела и панель admondey (без второго логина).
// На localhost/dev домен не указываем — иначе браузер отклонит cookie и вход
// в кабинет сломается.
const AUTH_DOMAIN = "antilaundry.ru";

const cookieDomainOpt = (): { domain?: string } => {
    if (typeof window === "undefined") return {};
    const host = window.location.hostname;
    return host === AUTH_DOMAIN || host.endsWith("." + AUTH_DOMAIN)
        ? {domain: "." + AUTH_DOMAIN}
        : {};
};

class TokenService {
    getLocalRefreshToken(): string | undefined {
        return getCookie("refresh_token");
    }

    getLocalAccessToken(): string | undefined {
        return getCookie("access_token");
    }

    updateLocalAccessToken(token: string, expiresIn: number): void {
        const currentTime = new Date().getTime();
        const expires = new Date(currentTime + expiresIn);
        // сначала убрать возможную старую host-only cookie, чтобы не осталось
        // двойника (host-only + доменная) с неоднозначным чтением
        deleteCookie('access_token');
        setCookie('access_token', token, {expires, ...cookieDomainOpt()});
    }

    updateLocalRefreshToken(token: string, expiresIn: number) {
        const currentTime = new Date().getTime();
        const expires = new Date(currentTime + expiresIn);
        deleteCookie('refresh_token');
        setCookie('refresh_token', token, {expires, ...cookieDomainOpt()});
    }

    removeTokens() {
        // чистим и host-only, и доменную cookie
        deleteCookie('access_token');
        deleteCookie('refresh_token');
        const domainOpt = cookieDomainOpt();
        if (domainOpt.domain) {
            deleteCookie('access_token', domainOpt);
            deleteCookie('refresh_token', domainOpt);
        }
    }
}

export default new TokenService();
